<div class="atn-mosaic-widget-footer">
  @switch (widgetStore.typeSg()) {
    @case (WidgetTypeEnum.Charts) {
      <atn-mosaic-chart-footer />
    }
    <!-- TODO: Cases for other widget types should be implemented -->
    @default {
      <div class="atn-mosaic-widget-footer__buttons">
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          type="primary"
          (click)="saveButtonClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    }
  }
</div>
